import { Outlet, Navigate } from "react-router-dom";
import authService from "../features/auth/authService";
function PrivateRoutes() {
      let isLoggedIn = authService.isLoggedIn();
      // let isLoggedIn = true;

      return (
            isLoggedIn ? <Outlet /> : <Navigate to='/login' />
      )
}

export default PrivateRoutes